/* Blocks checkout while the cart holds a preorder item and the confirmation
   checkbox in the cart footer is unticked. Markup lives in snippets/cart-footer.liquid;
   loaded as a module from snippets/drawer-cart.liquid so it runs once per page. */

function syncExpressButtons() {
  document.querySelectorAll('[data-cart-footer]').forEach((footer) => {
    const express = footer.querySelector('[data-preorder-express]');
    if (!express) return;
    const box = footer.querySelector('[data-preorder-checkbox]');
    express.hidden = !!(box && !box.checked);
  });
}

function showError(footer) {
  const wrap = footer.querySelector('[data-preorder-confirm]');
  const error = footer.querySelector('[data-preorder-error]');
  if (error) error.hidden = false;
  if (wrap) {
    wrap.classList.remove('preorder-error');
    void wrap.offsetWidth; // restart the shake animation on repeat clicks
    wrap.classList.add('preorder-error');
    wrap.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const box = wrap.querySelector('[data-preorder-checkbox]');
    if (box) box.focus({ preventScroll: true });
  }
}

function clearErrors() {
  document.querySelectorAll('[data-preorder-error]').forEach((el) => {
    el.hidden = true;
  });
  document.querySelectorAll('[data-preorder-confirm]').forEach((el) => {
    el.classList.remove('preorder-error');
  });
}

function blockIfUnconfirmed(e, submitter) {
  const footer = submitter.closest('[data-cart-footer]');
  if (!footer) return;
  const box = footer.querySelector('[data-preorder-checkbox]');
  if (box && !box.checked) {
    e.preventDefault();
    e.stopPropagation();
    showError(footer);
  }
}

document.addEventListener(
  'click',
  (e) => {
    const btn = e.target.closest('input[name="checkout"], button[name="checkout"]');
    if (btn) blockIfUnconfirmed(e, btn);
  },
  true
);

// Backstop for submissions that bypass the click path (e.g. form.requestSubmit).
document.addEventListener(
  'submit',
  (e) => {
    if (e.submitter && e.submitter.name === 'checkout') blockIfUnconfirmed(e, e.submitter);
  },
  true
);

document.addEventListener('change', (e) => {
  const box = e.target;
  if (!(box instanceof HTMLInputElement) || !box.hasAttribute('data-preorder-checkbox')) return;
  // The drawer and the cart page can both render a checkbox; keep them in sync.
  document.querySelectorAll('[data-preorder-checkbox]').forEach((other) => {
    other.checked = box.checked;
  });
  if (box.checked) clearErrors();
  syncExpressButtons();
});

// The theme morphs cart HTML from fresh section renders after add-to-cart and
// quantity changes. The server never knows the checkbox state, so re-derive the
// express-button visibility once the morph listeners have run.
['shapes:modalcart:afteradditem', 'shapes:modalcart:cartqtychange'].forEach((name) => {
  window.addEventListener(name, () => setTimeout(syncExpressButtons, 0));
});

syncExpressButtons();
